import type { ChangeEvent } from "react";
import { noop } from "lodash";

interface Option {
  label: string;
  value: string | number;
}

interface CustomSelectInputProps {
  disabled?: boolean;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
  value?: string;
}

export const CustomSelectInput = ({
  name,
  options,
  onChange = noop,
  disabled = false,
  value = "",
}: CustomSelectInputProps) => (
  <select
    className="disabled:bg-secondary form-control w-full"
    name={name}
    onChange={onChange}
    disabled={disabled}
    value={value}
  >
    {options.map(({ label, value }) => (
      <option key={value} value={value}>
        {label}
      </option>
    ))}
  </select>
);
